import { createContext, useContext, useState, useCallback } from 'react';

const SidebarContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
  toggleSidebar: () => {},
  // Estado da gaveta (drawer) no mobile — independente do "collapsed" do desktop
  mobileOpen: false,
  setMobileOpen: () => {},
  openMobileSidebar: () => {},
  closeMobileSidebar: () => {},
  toggleMobileSidebar: () => {},
});

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  // Controla a gaveta da sidebar no mobile (< md). No desktop este estado é ignorado.
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setCollapsed(prev => !prev);
  }, []);

  const openMobileSidebar = useCallback(() => {
    setMobileOpen(true);
  }, []);

  const closeMobileSidebar = useCallback(() => {
    setMobileOpen(false);
  }, []);

  const toggleMobileSidebar = useCallback(() => {
    setMobileOpen(prev => !prev);
  }, []);

  return (
    <SidebarContext.Provider value={{
      collapsed,
      setCollapsed,
      toggleSidebar,
      mobileOpen,
      setMobileOpen,
      openMobileSidebar,
      closeMobileSidebar,
      toggleMobileSidebar,
    }}>
      {children}
    </SidebarContext.Provider>
  );
}
